import axios from 'axios'
import HTTP from './http'

export default {
    getList: payload => axios.get(HTTP.RIGHT_PARAMETER_LIST, { params: { id: payload } }),
    updateRightParameter: payload => axios.post(HTTP.RIGHT_PARAMETER, payload),
    deleteRightParameters: payload => axios.delete(HTTP.RIGHT_PARAMETER, { params: { ...payload } })
}
